import { spotlight } from "@/mocks/homeData";

export default function Spotlight() {
  return (
    <section
      id="spotlight"
      className="w-full bg-background-100 py-14 md:py-20"
    >
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="overflow-hidden rounded-3xl border border-background-200 bg-background-50">
          <div className="grid grid-cols-1 lg:grid-cols-2">
            <div className="relative min-h-[300px] lg:min-h-full">
              <img
                src={spotlight.cover}
                alt={`${spotlight.title}编辑精选短篇漫画专题插画`}
                className="absolute inset-0 h-full w-full object-cover object-top"
              />
            </div>
            <div className="p-8 md:p-12">
              <div className="flex flex-wrap items-center gap-2">
                <span className="inline-flex items-center gap-1 rounded-full bg-primary-500 px-3 py-1 text-xs font-bold text-background-50">
                  <i className="ri-medal-line" />
                  本周编辑精选
                </span>
                <span className="rounded-full bg-accent-100 px-3 py-1 text-xs font-bold text-accent-800">
                  {spotlight.subtitle}
                </span>
              </div>
              <h2 className="font-heading mt-5 text-2xl leading-snug text-foreground-950 md:text-4xl">
                {spotlight.headline}
              </h2>
              <p className="mt-4 text-sm leading-relaxed text-foreground-700 md:text-base">
                {spotlight.description}
              </p>
              <ul className="mt-5 space-y-2.5">
                {spotlight.points.map((p) => (
                  <li
                    key={p}
                    className="flex items-center gap-2 text-sm text-foreground-800"
                  >
                    <i className="ri-checkbox-circle-fill text-accent-500" />
                    {p}
                  </li>
                ))}
              </ul>
              <div className="mt-7 flex flex-col gap-4 sm:flex-row sm:items-center">
                <a
                  href="#featured"
                  onClick={(e) => {
                    e.preventDefault();
                    document
                      .querySelector("#featured")
                      ?.scrollIntoView({ behavior: "smooth" });
                  }}
                  className="inline-flex items-center justify-center gap-1 whitespace-nowrap rounded-full bg-primary-500 px-6 py-3 text-sm font-bold text-background-50 transition-colors hover:bg-primary-600"
                >
                  现在就去读
                  <i className="ri-arrow-right-line" />
                </a>
                <span className="flex items-center gap-1 text-sm text-foreground-500">
                  <i className="ri-file-text-line" />
                  {spotlight.meta}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}